export default "__VITE_ASSET__CXNydRkb__"